import { ThemeSelectors } from "@at/design-system-foundation";
import { Modal } from "@at/design-system-patterns";
import { BREAKPOINTS } from "@at/window-utils";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
  section {
    overflow: hidden;
    padding: 0;
  }

  section:first-of-type > div:first-of-type {
    display: none;
  }
`;

export const GridModal = styled.div`
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow: scroll;
  background-color: ${({ theme }) => ThemeSelectors.getWhite(theme)};
  transition: top 0s linear 0s, opacity 0.6s ease 0.02s;
`;

export const SliderModal = styled.div`
  display: flex;
  flex-flow: column;
  height: 100dvh;
  transition: top 0s linear 0s, opacity 0.6s ease 0.02s;
`;

export const GalleryIconBar = styled.div<{
  hasMultipleMediaTypes?: boolean;
  onSliderModal?: boolean;
}>`
  position: sticky;
  background-color: ${({ theme, onSliderModal }) =>
    onSliderModal ? "transparent" : ThemeSelectors.getWhite(theme)};
  z-index: 999;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: start;
  padding: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)}
    ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  min-height: ${({ hasMultipleMediaTypes }) =>
    hasMultipleMediaTypes ? "136px" : "78px"};

  @media screen and (min-width: ${BREAKPOINTS.MEDIUM}px) {
    min-height: 78px;
  }
`;

export const Save = styled.div`
  display: flex;
  .save-advert-button {
    box-shadow: none;
    padding: 0;
    margin-right: 1px;
    height: auto;
    width: 30px;
    :hover {
      color: #780b0b;
    }
    svg {
      height: 24px;
      width: 24px;
    }
  }
`;

export const SaveShareContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 150px;
`;
